import { ArrowLeftIcon } from "@heroicons/react/outline";
import PermissionTable from "Component/PermissionTable";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React from "react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import { handleError } from "Helper";

function UpdatePermissionGroup() {
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  const [flag] = useState(argumentData?.flag || "isEdit");
  const [isLoading, setIsLoading] = useState(false);
  const [uuid] = useState(argumentData?.id || "");
  const [permissionName, setPermissionName] = useState(
    argumentData?.permission_name || ""
  );
  const [permissionFlag, setPermissionFlag] = useState(
    argumentData?.permission_flag_object !== null ||
      argumentData?.permission_flag_object !== undefined
      ? JSON.parse(argumentData?.permission_flag_object)
      : {
          monitoring: false,
          streaming: {
            addData: false,
            updateData: false,
            deleteData: false,
          },
          playback: {
            addData: false,
            updateData: false,
            deleteData: false,
          },
          dpo: {
            addData: false,
            updateData: false,
            deleteData: false,
          },
          register_face: {
            addData: false,
            updateData: false,
            deleteData: false,
          },
          operation: {
            addData: false,
            updateData: false,
            deleteData: false,
          },
          user: {
            addData: false,
            updateData: false,
            deleteData: false,
          },
        }
  );
  const [dataTable] = useState([
    {
      menu: "Pengaturan Streaming",
      key: "streaming",
    },
    {
      menu: "Pengaturan Playback",
      key: "playback",
    },
    {
      menu: "Daftar Pencarian Orang",
      key: "dpo",
    },
    {
      menu: "Daftar Wajah Baru",
      key: "register_face",
    },
    {
      menu: "Operasi Kepolisian",
      key: "operation",
    },
    {
      menu: "Pengguna",
      key: "user",
    },
  ]);
  const [headerTable] = useState([
    {
      label: "Menu",
      key: "menu",
      align: "start",
      width: "50%",
    },
  ]);

  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.master_data.permission_group.permission_group_home);
  };
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  // ==================== Default ==================== //

  const updateData = async () => {
    try {
      setIsLoading(true);
      const reqBody = {
        permission_name: permissionName,
        permission_flag_object: JSON.stringify(permissionFlag),
      };
      const response = await fetchApi().put(
        `/permission-group/update/${uuid}`,
        reqBody
      );
      setIsLoading(false);
      handleSuccess(response.data?.message);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    updateData();
  };

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          {flag === "isEdit"
            ? "Ubah Data Grup Izin Akses"
            : "Detail Data Grup Izin Akses"}
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-full">
              <label
                htmlFor="permission_name"
                className="flex block text-sm font-medium leading-6"
              >
                Nama Izin Akses
                {flag === "isShow" ? null : (
                  <p className="ml-1 text-red-700">*</p>
                )}
              </label>
              <div className="mt-2">
                {flag === "isShow" ? (
                  <label
                    htmlFor="permission_name"
                    className="block text-2xl font-boldleading-6"
                  >
                    {permissionName}
                  </label>
                ) : (
                  <input
                    id="permission_name"
                    name="permission_name"
                    type="text"
                    disabled={isLoading}
                    value={permissionName}
                    placeholder="Masukkan Nama Operasi"
                    onChange={(e) => setPermissionName(e.target.value)}
                    required
                    className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                )}
              </div>
            </div>
          </div>

          <label
            htmlFor="permission_name"
            className="ml-5 block text-sm font-medium leading-6 mb-2"
          >
            Izin Akses
          </label>

          <div className="mb-2 py-3 px-3 ml-5 mr-5 w-auto border-2 border-gray-200 flex items-center rounded-xl">
            <div className="flex justify-between w-full items-center">
              <label className="block text-sm font-medium leading-6">
                Event Monitoring
              </label>
              <input
                id="monitoring"
                type="checkbox"
                className="h-5 w-5"
                disabled={flag === "isShow"}
                checked={
                  permissionFlag.hasOwnProperty("monitoring")
                    ? permissionFlag.monitoring
                    : false
                }
                onChange={(event) => {
                  const updatedIsChecked = {
                    ...permissionFlag, // Salin state lama
                    monitoring: event.target.checked,
                  };
                  setPermissionFlag(updatedIsChecked);
                }}
              />
            </div>
          </div>

          <div className="mb-5 py-3 px-3 ml-5 mr-5 w-auto border-2 border-gray-200 items-center rounded-xl">
            <label className="mb-3 w-full items-center block text-sm font-medium leading-6">
              Manajemen Data
            </label>
            <PermissionTable
              isLoading={isLoading}
              headerData={headerTable}
              Data={dataTable}
              isDisabled={flag === "isShow"}
              isCheckedFlag={permissionFlag}
              // onChange={(data) => {
              //   const updatedIsChecked = {
              //     ...data,
              //     ...permissionFlag, // Salin state lama
              //   };
              //   setPermissionFlag(updatedIsChecked);
              // }}
              onChange={(data) => {
                setPermissionFlag((prev) => ({
                  ...prev,
                  ...data,
                  monitoring: prev.monitoring,
                }));
              }}
            />
          </div>

          {flag === "isEdit" ? (
            <div className="flex items-center justify-end mr-5">
              <button
                type="submit"
                className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                Simpan
              </button>
            </div>
          ) : null}
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}
export default UpdatePermissionGroup;
